export default "__VITE_ASSET__B6JWUY4r__"